// angular imports
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';

// cc-common imports
import { DxWidgetUtils, IconConstants, MessageBoxComponent, Utils } from 'cc-common';

// devextreme imports
import { DxPopupComponent } from 'devextreme-angular';

// model imports
import { ReverseEditorResultDto } from '../../../../../../src/app/shared-module/_models/reverse-editor-result-dto';

@Component({
    selector: 'app-ap-reverse',
    templateUrl: './ap-reverse.component.html',
    styleUrls: ['./ap-reverse.component.scss']
})
export class APReverseComponent implements OnInit, OnChanges {
    @ViewChild('reverseAPPopup', { static: false }) reverseAPPopup: DxPopupComponent;
    @ViewChild('reverseMessageBox', { static: false }) reverseMessageBox: MessageBoxComponent;

    @Input() reverseEditorData: ReverseEditorResultDto;
    @Input() title: string;
    @Input() isReasonMandatory = true;

    @Output() onReverse = new EventEmitter<any>();
    @Output() onClose = new EventEmitter<boolean>();

    visible = false;
    isReversed = false;

    reverseReason: string;

    height: string;

    iconCancel = IconConstants.CANCEL;
    iconYes = IconConstants.CHECK;

    ngOnInit() {
        this.height = Utils.isTrue(this.isReasonMandatory) ? '40%' : '15%';

        this.show();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (
            Utils.notNullAndDefined(changes.reverseEditorData) &&
            Utils.notNullAndDefined(changes.reverseEditorData.currentValue)
        ) {
            this.reverseEditorData = changes.reverseEditorData.currentValue;
        }
    }

    show(): void {
        this.visible = true;
    }

    onShown(): void {
        DxWidgetUtils.instantRepaint(this.reverseAPPopup);
    }

    onHidden(): void {
        this.closeReverseAP();
    }

    onCancelClick(): void {
        this.closeReverseAP();
    }

    onYesClick(): void {
        if (Utils.isTrue(this.isReasonMandatory) && Utils.isNullOrEmpty(this.reverseReason)) {
            this.reverseMessageBox.showErrorMessage('Error', 'Reason is mandatory.');
        } else {
            this.onReverseSubmit();
        }
    }

    private onReverseSubmit(): void {
        this.onReverse.emit({
            reverseDate: this.reverseEditorData.reverseDate,
            reverseReason: this.reverseReason
        });
    }

    private closeReverseAP(): void {
        this.visible = false;
        this.onClose.emit();
    }
}
